export default __webpack_public_path__ + "static/media/amazon-logo-white.79d0180e.png";